import angular from "angular";
// angular register angular modules
export const moduleName = 'clientDashboardApp.chatmeterAdmin.manageTool'
const mod = angular.module(moduleName, []);
// redux store value
import {reduxStore} from "../../angularReactRedux/reduxStore";
// react wrapper that provides injected context
import {Provider} from "react-redux"
import React from "react"
import {CommandsProvider, ManageToolFilters, ManageToolJobsList} from "./components"
import * as commands from './manageToolCommands'

mod.value('ReactManageToolFilters', ({  }) => {
    return (<Provider store={reduxStore}>
      <CommandsProvider commands={commands}>
        <ManageToolFilters/>
      </CommandsProvider>
    </Provider>)
  }
)

mod.value('ReactManageToolItems', ({  }) => {
  return (<Provider store={reduxStore}>
    <CommandsProvider commands={commands}>
      <ManageToolJobsList/>
    </CommandsProvider>
  </Provider>)
})

// state
mod.config($stateProvider => {
  $stateProvider
    .state('manageTool', {
      url: '/manageTool',
      template: `
<div class="row mt-4">
  <div class="col-md-3">
    <div class="panel panel-default filter-panel">
      <div class="panel-heading"><h5 class="no-margin">Filters</h5></div>
      <div class="panel-body">
        <react-component name="ReactManageToolFilters" props="props" watch-depth="reference"></react-component>
      </div>
    </div>
    <hr />
  </div>
  <div class="col-md-9">
    <react-component name="ReactManageToolItems" props="props" watch-depth="reference"></react-component>
  </div>
`,
      controller: ($scope) => {
        $scope.props = { }
      }
    })
});
